import { useCallback } from 'react';
import { useAsset } from '@artica/assets';
import { parallax } from '@immutabl3/alchemy/three';
import competitionPathOffset from './competitionPathOffset.animations.json';
import animations from './competitionCardPath.animations.json';
import { CURVE_PATH_LIMIT as pathLimit } from '@artica/constants';
import {
  Color,
  MathUtils,
  AdditiveBlending,
} from 'three';

export default function CompetitionCardPath({
  index,
  curve,
}) {
  const texture = useAsset('dot_sprite');
  const onAnimation = useCallback((sprite, anim) => {
    const { animations } = anim;
    const [{ currentValue: offset }] = animations;
    const position = curve.getPoint(
      MathUtils.clamp(offset + 0.855, 0, pathLimit)
    );
    sprite.position.x = position.x;
    sprite.position.y = position.y;
    sprite.position.z = position.z;
  }, [curve]);

  return (
    <parallax.sprite
      scale={ 2 }
      beaker="chapter1"
      animation={ competitionPathOffset[index] }
      onAnimation={ onAnimation }
    >
      <parallax.spriteMaterial
        beaker="chapter1"
        animation={ animations[index] }

        attach="material"
        blending={ AdditiveBlending }
        color={ new Color(3.0, 2.0, 1.6) }
        fog={ false }
        map={ texture }
        depthTest={ false }
        depthWrite={ false }
        sizeAttenuation
      />
    </parallax.sprite>
  );
};